import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export const trackRemoveFromCart = ({
  currency,
  removedItem,
}: {
  currency: string;
  removedItem?: EcommerceCartItem;
}) => {
  pushToDataLayer({
    event: 'remove_from_cart',
    ecommerce: {
      currency,
      items: [removedItem],
    },
  });
};
